import React from 'react';
import styled from 'styled-components';
const colors = require('common/lib/colors/colors.less');
import TrelloLogoIcon from '../icons/TrelloLogo';

const TrelloLogo = (props) => (
  <TrelloLogoIcon {...props} color={colors.N60} aria-labelledby="title" />
);

export default TrelloLogo;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/TrelloLogo.js